/**
 * URL Parameter Utilities
 */
const getSafeParams = () => {
  const search = window.location.search.replace(/&amp;/g, '&');
  return new URLSearchParams(search);
};

export const getClientIdFromUrl = () => {
  return getSafeParams().get('clientId') || 'test_user';
};

export const getUserIdFromUrl = () => {
  return getSafeParams().get('userId') || 'test_user';
};

export const getLogoUrlFromUrl = () => {
  return getSafeParams().get('logoUrl') || null;
};

export const getCompanyNameFromUrl = () => {
  return (
    getSafeParams().get('companyName') ||
    getSafeParams().get('brandName') ||
    null
  );
};

